import { mapActions, mapGetters } from "vuex";
import * as types from "@/store/types";
import { OrderService, WalletService } from "@/services";
import dayjs from "@/utiles/dayjs";
import socket from "@/services/sockets/order-socket";
import $thousandMask from "@/mixins/thousandMask";

export default {
  name: "orders-list-dialog",
  components: {},
  props: {
    maxWidthValue: {
      type: Number
    }
  },
  mixins: [$thousandMask],
  data() {
    return {
      page: 1,
      paginationPageSize: 10,
      selectedTab: 0,
      orderListLoader: true,
      headers: this.$t("orderPage.orderList.dataTableHeader"),
      headersWithOutOperation: this.$t(
        "orderPage.orderList.dataTableHeaderWithoutOperation"
      ),
      headerFlag: false,
      ordersList: [],
      orderStatus: ""
    };
  },
  filters: {
    formatDate(date) {
      return dayjs(date).format("HH:mm YYYY/MM/DD");
    },
    formatTime(time) {
      return dayjs(time).format("HH : mm");
    }
  },
  computed: {
    ...mapGetters({
      getOrdersData: types.order.getters.GET_ORDERS_DATA,
      getUserInfo: types.userInfo.getters.GET_USER_INFO,
      getOrderListStep: types.orderListStep.getters.GET_ORDER_LIST_STEP
    }),
    filteredOrdersList() {
      if (this.getOrderListStep) {
        this.selectedTab = 0;
        this.setOrderListStep(false);
        this.orderStatus = "";
      }
      this.updateOrderSocket(this.getUserInfo.id);
      let orderList = [];
      this.getOrdersData.data.find(elem => {
        if (!this.orderStatus) {
          orderList.push(elem);
        } else if (elem.status.toUpperCase() === this.orderStatus) {
          orderList.push(elem);
        }
      });
      this.orderListLoader = false;
      return orderList;
    },
    filteredHeaders() {
      if (Object.entries(this.filteredOrdersList).length !== 0) {
        let head = this.filteredOrdersList.find(
          elem => elem.is_cancelable === true
        );
        if (head) {
          return this.headers;
        } else {
          return this.headersWithOutOperation;
        }
      }
    }
  },
  mounted() {
    this.getFilterOrder();
  },
  methods: {
    ...mapActions({
      setOrdersData: types.order.actions.SET_ORDERS_DATA,
      updateOrdersData: types.order.actions.UPDATE_ORDERS_DATA,
      setOrderListStep: types.orderListStep.actions.SET_ORDER_LIST_STEP,
      walletDataAction: types.wallets.actions.SET_WALLETS
    }),
    cancelOrder(item) {
      OrderService.cancelMarketOrder(item.reference_number).then(res => {
        this.$toast.success(res.data.message);
        const filters = {
          sort: "desc",
          status: this.orderStatus
        };

        OrderService.getMarketOrders(filters).then(res => {
          this.setOrdersData(res.data);
        });
        WalletService.getWallet().then(response => {
          this.walletDataAction(response.data.data);
        });
      });
    },
    updateOrderSocket(user_id) {
      if (user_id) {
        socket.ECHO.private("market_order." + user_id).listen(
          ".market_order.status.updated",
          event => {
            this.updateOrdersData(event);
          }
        );
      }
    },
    resetPageCounter() {
      this.page = 1;
    },
    getFilterOrder(status) {
      this.orderStatus = status;
      const filters = {
        sort: "desc",
        status: this.orderStatus,
        page: this.page
      };

      OrderService.getMarketOrders(filters).then(response => {
        this.setOrdersData(response.data);
      });
    }
  }
};
